import { AddOutlined, KeyOutlined } from "@mui/icons-material";
import { Box, Container, Grid, Tab, Tabs } from "@mui/material";
import { useContext, useState } from "react";
import {
    ListDetailViewSectionContent,
    ListDetailViewSectionHeader,
    ListDetailViewSectionLayout,
} from "../../components/ListDetailView";
import { PeriodSelector } from "../../components/Period";
import { useUserInfo } from "../../utils/security";
import { FilterContext } from "../../components/Filter";

export const PricelistsOverview = ({
    employeeId,
    loading,
    onAddPricelist,
    onShowRecurringDialog,
    ...others
}) => {
    const { userInfo, hasRight } = useUserInfo();
    const { setFilter, filter } = useContext(FilterContext);

    return (
        <ListDetailViewSectionLayout loading={loading}>
            <ListDetailViewSectionHeader
                title="Přehled ceníků"
                titleNode={
                    <>
                        <PeriodSelector
                            value={filter.period || {}}
                            onChange={(period) => setFilter({ ...filter, period })}
                            disabled={loading}
                            withDetail
                        />
                    </>
                }
                role="overview"
                loading={loading}
                actions={[
                    {
                        title: "Přidat",
                        icon: <AddOutlined />,
                        onClick: onAddPricelist,
                    },
                ]}
            />
            <ListDetailViewSectionContent>
                {/*<PeriodField />*/}
                <Container maxWidth="xl">
                    <Box sx={{ py: 4 }}>TODO</Box>
                </Container>
            </ListDetailViewSectionContent>
        </ListDetailViewSectionLayout>
    );
};
